
define('text!modules/audiences/segments/templates/rowExpand.html',[],function () { return '<strand-spinner class="loading-row-spinner" radius="9"  line-width="3.5" line-weight="1.5" fill-color="#333333"></strand-spinner>\n<div class="open-close">\n\t<div class="triangle triangle-right"></div>\n</div>';});

